/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import type { TabsTriggerProps } from '@radix-ui/react-tabs';
import { Bell, KeySquare } from 'lucide-react';
import { Link, Outlet, useLocation } from 'react-router';

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { cn } from '@/lib/utils';

interface TabProps extends TabsTriggerProps {
    to: string;
}

const Tab = ({ className, children, to, ...props }: TabProps) => {
    return (
        <TabsTrigger
            asChild
            className={cn(
                // eslint-disable-next-line max-len
                'relative h-9 rounded-none border-b-2 border-b-transparent bg-transparent px-4 pb-3 pt-2 font-semibold text-muted-foreground shadow-none transition-none data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:shadow-none',
                className,
            )}
            {...props}
        >
            <Link to={to}>{children}</Link>
        </TabsTrigger>
    );
};

export default function Organisation() {
    const location = useLocation();
    const tab = location.pathname.split('/')[2];
    return (
        <main className="w-full px-6 mx-auto max-w-7xl">
            <h1 className="text-2xl font-semibold mb-8">Organisation Settings</h1>
            <Tabs defaultValue={tab} value={tab} className="relative w-full">
                <div className="flex items-center justify-between pb-3">
                    <TabsList className="w-full h-9 justify-start rounded-none border-b bg-transparent p-0">
                        <Tab value="general" to="/organisation/general">
                            General
                        </Tab>
                        <Tab value="members" to="/organisation/members">
                            Members
                        </Tab>
                        <Tab value="subscriptions" to="/organisation/subscriptions">
                            Subscriptions
                        </Tab>
                        <Tab value="notification" to="/organisation/notification" className="flex flex-row gap-1">
                            <Bell size={16} />
                            Notification
                        </Tab>
                        <Tab value="keys" to="/organisation/keys" className="flex flex-row gap-1">
                            <KeySquare size={16} />
                            Keys
                        </Tab>
                    </TabsList>
                </div>
                <Outlet />
            </Tabs>
        </main>
    );
}
